import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Wifi } from 'lucide-react';
// import { useTranslation } from 'react-i18next';

import { Page } from '@/app/routes';
import { Paragraph } from '@app/shared/ui/atoms/Common';
// import { formatMonthYear } from '@app/shared/utils/common';
import { navbarDOMLogoBlack } from '@app/assets';

export interface WalletCardProps {
  userName?: string | null;
  cardNumber?: string;
  registrationDate?: number;
}

export const WalletCard = ({
  userName,
  // cardNumber, registrationDate
}: WalletCardProps) => {
  const { t } = useTranslation();

  return (
    <div className="mx-auto flex h-[200px] w-full max-w-[350px] flex-col justify-between rounded-[15px] bg-[linear-gradient(163deg,#439df6_0%,#0763be_100%)] p-5 shadow-[0_4px_4px_#00000040]">
      <div className="flex justify-between">
        <img src={navbarDOMLogoBlack} alt="dom-logo" />
        <Wifi color="white" size={30} className="stroke-4 rotate-45" />
      </div>
      <div className="flex justify-center">
        <Link
          to={Page.BALANCE_HISTORY}
          className="bg-[linear-gradient(0deg,#3063f6_0%,#074891_100%)] px-2 py-1 text-white rounded-full"
        >
          <div className="flex items-center gap-1">{t('bank.balance.history')}</div>
        </Link>
      </div>
      <div className="flex flex-col gap-2">
        <div>
          <Paragraph size="xs" className="text-foreground">
            {userName}
          </Paragraph>
          {/*<Paragraph size="xl" className="font-bold text-foreground">*/}
          {/*  {cardNumber}*/}
          {/*</Paragraph>*/}
        </div>
        {/*<div>*/}
        {/*  <Paragraph size="xs" className="text-foreground">*/}
        {/*    {t('bank.registered_date')}*/}
        {/*  </Paragraph>*/}
        {/*  {registrationDate && (*/}
        {/*    <Paragraph size="xl" className="font-bold text-foreground">*/}
        {/*      {formatMonthYear(registrationDate)}*/}
        {/*    </Paragraph>*/}
        {/*  )}*/}
        {/*</div>*/}
      </div>
    </div>
  );
};
